import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import {
  Dialog, DialogActions, DialogContent, Button,
} from '@mui/material';

import DateRangeSelector from './date-range-selector';

class DateRangeDialog extends React.Component {
  constructor(props) {
    super(props);
    const { to, from } = this.props;

    this.state = {
      isOpen: false,
      startDate: to,
      endDate: from,
    };

    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDateSave = this.handleDateSave.bind(this);
  }

  handleClickOpen = () => {
    this.setState({ isOpen: true });
  };

  handleClose = () => {
    this.setState({ isOpen: false });
  };

  handleDateChange(event) {
    const { to, from } = event;
    if (to && from) {
      const newState = {
        startDate: moment(from),
        endDate: moment(to),
      };
      this.setState(newState);
    }
  }

  handleDateSave() {
    const { handleDateChange } = this.props;
    const { startDate, endDate } = this.state;
    handleDateChange(startDate, endDate);
    this.handleClose();
  }

  render() {
    const { isOpen, startDate, endDate } = this.state;

    return (
      <div>
        <Button variant="outlined" color="primary" onClick={this.handleClickOpen}>
          Choose Dates
        </Button>
        <Dialog
          open={isOpen}
          onClose={this.handleClose}
          aria-labelledby="form-dialog-title"
        >
          <DialogContent>
            <DateRangeSelector
              to={endDate}
              from={startDate}
              onChange={this.handleDateChange}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose} color="primary">
              Close
            </Button>
            <Button onClick={this.handleDateSave} color="primary">
              OK
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}
DateRangeDialog.defaultProps = {
  to: moment(),
  from: moment(),
};
DateRangeDialog.propTypes = {
  handleDateChange: PropTypes.func.isRequired,
  to: PropTypes.instanceOf(moment),
  from: PropTypes.instanceOf(moment),
};

export default DateRangeDialog;
